import { useTranslation } from 'react-i18next'
import { Documents } from '~/features/russia/Cars/Documents'
import { PageContainer } from '~/shared/ui/Layout'
import {
  QuickNavigation,
  QuickNavigationOptions,
} from '~/shared/ui/QuickNavigation'

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'pts', anchor: 'pts' },
  { labelI18n: 'sts', anchor: 'sts' },
  { labelI18n: 'license', anchor: 'taxiLicense' },
  { labelI18n: 'osago', anchor: 'osago' },
  { labelI18n: 'kasko', anchor: 'kasko' },
  { labelI18n: 'dc', anchor: 'dc' },
  { labelI18n: 'osgop', anchor: 'osgop' },
  { labelI18n: 'other', anchor: 'otherDocument' },
]

export const DocumentsPageRussia = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('car documents')}>
      <Documents />

      <QuickNavigation options={quickNavigationOptions} />
    </PageContainer>
  )
}
